"use client"

import type { NavigationLinkItem } from "config/navigation/types/NavigationLinkItem"
import { NavigationViews, rootNavigationState } from "features/navigation/state/rootNavigationState"
import type React from "react"
import { BLXApplications } from "types"
import useFeatureRoutes from "utils/routeBuilders/useFeatureRoutes/useFeatureRoutes"
import NavLinkItem from "../../components/NavLinkItem"

export const MarketMyBreweryNavigationLink: React.FC = () => {
    const { marketMyBreweryFeatureRoute } = useFeatureRoutes()

    const marketMyBrewery: NavigationLinkItem = {
        application: BLXApplications.Marketing,
        label: "MarketMyBrewery",
        path: marketMyBreweryFeatureRoute(),
        displayType: "link",
        // isDisabled: isOrgDashboardRoute && !activeBrandId,
        onClick: () => rootNavigationState.getState().setCurrentNavView(NavigationViews.MMB)
    }

    return <NavLinkItem item={marketMyBrewery} />
}

export default MarketMyBreweryNavigationLink
